import { IKeHoachKy } from "../../../model/respone/ke-hoach/IKeHoachKy";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachKyActionsObj = {
  LOAD_START: "",
  LOAD_SUCCESS: {} as IKeHoachKy[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IKeHoachKy | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IKeHoachKy,
  SAVE_SUCCESS: {} as IKeHoachKy,
  SAVE_ERROR: "",

  UPDATE_LOCK_STATUS_START: {} as IKeHoachKy,
  UPDATE_LOCK_STATUS_SUCCESS: undefined,
  UPDATE_LOCK_STATUS_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",
};
export const eKeHoachKyActionIds = generateActionTypeIds(
  eKeHoachKyActionsObj,
  "KE_HOACH_KY"
);
export type IKeHoachKyActionTypes = IGenericActionType<
  typeof eKeHoachKyActionsObj,
  "KE_HOACH_KY"
>;
